module.exports = __webpack_public_path__ + "static/insee-37c4faf429b21f6d7c3f1cd11256e155.png";